import { useCallback } from 'react';

import { useMytaverse } from '@providers/MytaverseProvider';
import SDService from '@clients/ek/services/SDService';
import { restoringFocusDownload } from '@helpers/screenshotCanvas';
import { IXRHrGenderTypes } from '@clients/ek/interfaces';
import { GenderType } from '@features/avaturn/interfaces';
import { MytaverseLogger } from '@helpers/logger';
import { useMytaverseEvent } from '@core/dashboard/providers';
import { AnalyticsType } from '@interfaces/analytics';

const useCrowningMomentDownload = () => {
  const { user } = useMytaverse();
  const { trackEventAnalytics } = useMytaverseEvent();

  return useCallback(async () => {
    if (!user?.hrData) {
      return;
    }

    try {
      const persona = user.hrData.persona.toLowerCase()?.replace(' ', '') || '';
      const { file } = await SDService.crowningMomentDownload({
        gender:
          user.hrData.gender === IXRHrGenderTypes.F
            ? GenderType.FEMALE
            : GenderType.MALE,
        persona: persona === 'purser' ? 'purser' : 'cabincrew',
      });

      if (!file) {
        MytaverseLogger.log('Cannot generate file');
        return;
      }

      const response = await fetch(file);
      if (!response.ok) {
        throw new Error(`Failed to fetch: ${response.status}`);
      }

      const blob = await response.blob();

      restoringFocusDownload(
        URL.createObjectURL(blob),
        'crowning_moment_video.mp4',
      );

      trackEventAnalytics(AnalyticsType.SDDownloadCrowningMoment);
    } catch (error) {
      console.log('error', error);
    }
  }, [user]);
};

export default useCrowningMomentDownload;
